import * as React from 'react';
import { Button } from './Button';
export const PageHeroTwo = ({ mobileTitle, title, subtitle, body, ctas, isTitleTopLevelHeader, }) => {
    const TitleElement = ({ as = 'div', className = '', children }) => {
        const Tag = as;
        return React.createElement(Tag, { className: className }, children);
    };
    const titleElement = (React.createElement(TitleElement, { as: isTitleTopLevelHeader ? 'h1' : 'div', className: "text-[40px] xl:text-[60px] leading-none max-w-[320px]" },
        React.createElement("span", { className: "font-medium hidden md:inline-block" },
            title,
            " "),
        React.createElement("span", { className: "hidden md:inline-block" }, subtitle),
        mobileTitle ? (React.createElement("span", { className: "font-medium md:hidden block" }, mobileTitle)) : (React.createElement("span", { className: "md:hidden block" },
            React.createElement("span", { className: "font-medium" },
                title,
                " "),
            subtitle))));
    return (React.createElement("div", { className: "flex flex-col sm:flex-row gap-6 sm:gap-8 justify-between xl:items-center px-2.5 sm:px-5 xl:px-10 py-6 xl:pb-5" },
        React.createElement("div", null, titleElement),
        React.createElement("div", { className: "flex flex-col lg:flex-row gap-6 xl:gap-12 justify-between lg:items-center w-full xl:w-[70%]" },
            React.createElement("div", { className: "max-w-[550px] [&_p]:text-sm" }, body),
            React.createElement("div", { className: "flex gap-10 [&_a]:sm:text-sm" }, ctas &&
                ctas.length > 0 &&
                ctas.map((cta, index) => {
                    const secondaryButton = index === 1;
                    return (React.createElement(Button, { asChild: true, key: index, variant: secondaryButton ? 'text' : 'default', size: "sm", className: secondaryButton ? 'text-brand-orange' : undefined }, cta));
                })))));
};
